// extracted by mini-css-extract-plugin
export default {"second_part":"second_second_part__iSi2S","second":"second_second__G2NBZ"};